<template>
  <div :class="['si-widget si-common-widgets', {'waf-match-info-v2': matchStories}]">
    <div
        class="si-masthead-container si-historic-event-cntnr"
        itemscope
        itemtype="https://schema.org/NewsArticle"
    >
      <match-info-head
        v-if="matchStories"
        :isArticleAvailable="isArticleAvailable"
        :last_updated_label="translations.last_updated_label"
        :article_button_details="getArticleButtonDetails()"
        :pageUrl="getPageUrl()"
        :pageHeadline="generateHeadline()"
        :article_mt_content="formatDateString(story_updated_date, 'article_content', true)"
        :article_mt_meta="formatDateString(story_updated_date, 'article_meta', true)"
        :article_pt_meta="formatDateString(story_created_date, 'article_meta', true)"
      />
      <match-info-head
        v-else
        :last_updated_label="translations.last_updated_label"
        :isArticleAvailable="isArticleAvailable"
        :article_button_details="getArticleButtonDetails()"
        :pageUrl="getPageUrl()"
        :pageHeadline="generateHeadline()"
        :article_mt_content="formatDateString(article_mt, 'article_content')"
        :article_mt_meta="formatDateString(article_mt, 'article_meta')"
        :article_pt_meta="formatDateString(article_pt, 'article_meta')"
      />
      <div v-if="matchStories" v-html="matchStories"></div>
      <div v-else-if="feed_data.length" class="si-infographic-content" itemprop="articleBody">
        <div v-if="show_htoh_image" class="si-row" key="match-image">
          <div class="si-box si-gallery">
            <div class="si-content-wrp">
              <div
                class="si-img-wrp"
                itemtype="https://schema.org/ImageObject"
                itemscope
                itemprop="image"
              >
                <img
                  class="si-img"
                  importance="high"
                  :src="`${match_image}?w=${image_compression_width}`"
                  :title="generateMatchTitle()"
                  :alt="generateMatchTitle()"
                />
                <meta itemprop="url" :content="match_image" />
                <meta itemprop="description" :content="generateMatchTitle()" />
              </div>
            </div>
          </div>
        </div>
        <div class="si-row" v-for="comm in feed_data" :key="comm.id">
          <div
              :class="['si-box', comm.display_pic ? 'si-gallery' : 'si-comments']" >
            <div class="si-content-wrp">
              <div
                  class="si-text-wrp"
                  v-if="comm.body"
                  v-html="comm.body"
              ></div>
              <div
                  class="si-img-wrp"
                  v-if="comm.display_pic"
                  itemtype="https://schema.org/ImageObject"
                  itemscope
                  itemprop="image"
              >
                <img
                  class="si-img"
                  loading="lazy"
                  :src="`${comm.display_pic}?w=${image_compression_width}`"
                  :title="comm.headline"
                  :alt="comm.headline"
                />
                <meta itemprop="url" :content="comm.display_pic"/>
                <meta itemprop="description" :content="comm.headline"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mobilecheck, getMatch, getMatchImageTitle, getDateString, getMatchInfoTitle, formatFullUrl} from "../../../assets/js/common";
import { CFG_API_DOMAIN, CFG_TEAM_NAME_MAP } from '../../../assets/js/config';
import MatchInfoHead from "./MatchInfoHead";
export default {
  props: ["parentRoute"],
  data() {
    return {};
  },
  components: {
    MatchInfoHead
  },
  computed: {
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    slug() {
      return this.$store.state.match_detail_store.slug;
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug) || {};
    },
    translations() {
      return this.$store.state.translations;
    },
    /**shared state end */
    feed_data() {
      return this.$store.state.fantasy_tips_store.feed_data;
    },
    show_htoh_image() {
      return this.$store.state.fantasy_tips_store.show_htoh_image;
    },
    isArticleAvailable() {
      return this.$store.state.fantasy_tips_store.isArticleAvailable;
    },
    match_image() {
      let currMatch = this.current_match;
      let mImgUrl = 'https://www.fantasygully.com/static-assets/images/16_9_Match-Tips.png';
      if(currMatch && currMatch.code) {
        mImgUrl = `https://www.fantasygully.com/static-assets/images/v5_800/${currMatch.code}.jpg`;
      }
      return mImgUrl;
    },
    article_mt() {
      return this.$store.state.fantasy_tips_store.article_mt;
    },
    article_pt() {
      return this.$store.state.fantasy_tips_store.article_pt;
    },
    story_created_date() {
      return this.$store.state.fantasy_tips_store.story_created_date;
    },
    story_updated_date() {
      return this.$store.state.fantasy_tips_store.story_updated_date;
    },
    image_compression_width() {
      let {ismobile} = this.$store.state;
      let defaultW = '720';
      if (ismobile) {
        defaultW = '320';
      } else if (mobilecheck()) {
        defaultW = '320';
      }
      return defaultW;
    },
    matchStories() {
      return this.$store.state.fantasy_tips_store.matchStories;
    },
  },
  mounted() {
    if (typeof document !== "undefined" && typeof window !== "undefined") {
      this.ddToggle();
    }
  },
  methods: {
    ddToggle() {
      let dd = document.getElementById("dropdownBtn");
      if(dd) {
        dd.addEventListener("click", () => {
          let dd_list = document.getElementsByClassName('dropdown-menu');
          if(dd_list && dd_list.length) {
            dd_list[0].classList.toggle('show');
          }
        });
        let ddItem = document.querySelectorAll("#section_id_selection_dd .dropdown-item");
        ddItem.forEach((item, idx) => {
          
          item.addEventListener("click", (e) => {
            // e.preventDefault();
            let textTarget = document.getElementById("dropdownBtn");
            textTarget.textContent = item.textContent;
            let dd_list = document.getElementsByClassName('dropdown-menu');
            if(dd_list && dd_list.length) {
              dd_list[0].classList.remove('show');
            }
            // this.smoothScroll(item)
          });
        });
      }
    },
    // smoothScroll(item) {
      // const href = item.getAttribute("href");
      // let headerHeight = document.querySelector(".site-header").offsetHeight;
      // let elementTop = document.querySelector(href).offsetTop;
      // window.scrollTo({top: elementTop, behavior: "smooth"});

      // const headerHeight = document.querySelector(".site-header").offsetHeight; 
      // const elementTop = document.querySelector(href).offsetTop;
      // console.log(href, headerHeight, elementTop, elementTop)
      // window.scrollTo({top: elementTop, behavior: "smooth"});

      // let elementTop = document.querySelector(href);
      // elementTop.scrollIntoView();
    // },
    formatDateString(datestring, type, ignoreTzAddition) {
      let published_time_utc;
      if (typeof datestring === "string") {
        published_time_utc = new Date(datestring);
        let publish_time_ist;
        if (ignoreTzAddition) {
          publish_time_ist = published_time_utc;
        } else {
          publish_time_ist =
            published_time_utc.getTime() + 5.5 * 60 * 60 * 1000;
        }

        if (type === "article_meta") {
          let date = getDateString(publish_time_ist, "day");
          let month = getDateString(publish_time_ist, "month_num");
          let year = getDateString(publish_time_ist, "year");
          let time = getDateString(publish_time_ist, "time24");
          return `${year}-${month}-${date}T${time}+05:30`;
        } else if (type === "article_content") {
          return `${getDateString(publish_time_ist, "month")} ${getDateString(
            publish_time_ist,
            "day"
          )}, ${getDateString(publish_time_ist, "year")} ${getDateString(
            publish_time_ist,
            "time"
          )} IST`;
        }
      }
    },
    getPageUrl() {
      let domain = CFG_API_DOMAIN.replace(/\/datafeeds\//, "");
      let path = (this.$store && this.$store.state && this.$store.state.route && this.$store.state.route.path) || '';
      return `${domain}${path}`;
    },
    updateTeamNames() {
      let matchObj = {...this.current_match};
      let { teams, league_code } = matchObj;
      if(league_code && league_code == "ipl") {
        let updatedTeams = teams.map((t) => {
          let mapTeam = CFG_TEAM_NAME_MAP.find(tm => tm.city_short === t.short_name);
          if(mapTeam) {
            t.name = mapTeam.official_name
            t.short_name = mapTeam.official_short_name;
          }
          return t;
        });
        matchObj.teams = updatedTeams;
      }
      return matchObj;
    },
    generateHeadline() {
      let matchObj = this.updateTeamNames();
      let isHindi = this.$route && this.$route.path && this.$route.path.includes("/hi/");
      return getMatchInfoTitle(matchObj, this.translations.match_tips_headline, false, isHindi);
    },
    generateMatchTitle() {
      return getMatchImageTitle(this.current_match);
    },
    getArticleButtonDetails() {
      let targetLang = this.$route && this.$route.path && this.$route.path.includes("/hi/") ? "en" : "hi";
      let targetLink = formatFullUrl(this.current_match, this.parentRoute, targetLang);
      return {
        label: this.translations.articleButtons[targetLang],
        link: targetLink
      };
    }
  },
};
</script>
